import { Box, createStyles, Skeleton, Text } from "@mantine/core";
import React from "react";
import { FaArrowTrendUp } from "react-icons/fa6";
import { FiArrowUp } from "react-icons/fi";
import { useSelector } from "react-redux";

const useStyles = createStyles(() => ({
  card: {
    borderRadius: "30px",
    backgroundColor: "#fff",
    padding: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    gap: "0.5rem",
  },
  bg: {
    backgroundImage: "url('/assets/images/cardBG.png')",
    backgroundSize: "contain",
    backgroundRepeat: "repeat",
    backgroundPosition: "left bottom",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  iconBG: {
    background: "#E5E5E5",
    borderRadius: "50%",
    padding: "1rem",
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  newCount: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
}));

const DashboardCards = ({ icon, title, count, newCount }) => {
  const { classes } = useStyles();
  const { loadingCount } = useSelector((state) => state.dashboard);

  return (
    <>
      <Box className={`${classes.card} ${classes.bg}`}>
        <Box className={classes.iconContainer}>
          <Box className={classes.iconBG}>{icon}</Box>
          <Text ff={"Inter"} fz={20}>
            {title}
          </Text>
        </Box>
        {loadingCount ? (
          <Skeleton height={50} width={50} />
        ) : (
          <Text ff={"Inter"} fz={30} fw={700}>
            {count}
          </Text>
        )}
        <Box className={classes.newCount}>
          {newCount === 0 ? null : title === "Active Staff" ? (
            <FaArrowTrendUp size={24} color="#039855" />
          ) : (
            <FiArrowUp size={24} color="#039855" />
          )}
          {loadingCount ? (
            <Skeleton width={30} height={30} />
          ) : (
            <Text ff="Inter" fz={14}>
              {`${newCount} ${
                title === "Active Staff" ? "Currently Active" : "New"
              }`}
            </Text>
          )}
        </Box>
      </Box>
    </>
  );
};

export default DashboardCards;
